import moment from 'moment'

export function setStepSession(name, stepNumber, value) {
  window.localStorage.setItem(`${name}-step${stepNumber}`, JSON.stringify(value))
}

export function getStepSession(name, stepNumber) {
  const value = window.localStorage.getItem(`${name}-step${stepNumber}`)
  return JSON.parse(value)
}

export function removeStepSession(name, stepNumber) {
  window.localStorage.removeItem(`${name}-step${stepNumber}`)
}

export function removeAllStepSession(name) {
  window.localStorage.removeItem(`${name}-step0`)
  window.localStorage.removeItem(`${name}-step1`)
  window.localStorage.removeItem(`${name}-step2`)
  window.localStorage.removeItem(`${name}-step3`)
  window.localStorage.removeItem(`${name}-step4`)
  window.localStorage.removeItem(`${name}-id`)
  window.localStorage.removeItem(`${name}-changes`)
  window.localStorage.removeItem(`${name}-changes-date`)
}

export function setStepObjectId(stepPrefix, value) {
  window.localStorage.setItem(`${stepPrefix}-id`, JSON.stringify(value))
}

export function getStepObjectId(stepPrefix) {
  const value = window.localStorage.getItem(`${stepPrefix}-id`)
  return JSON.parse(value)
}

export function markAsUnsavedSession(stepPrefix) {
  window.localStorage.setItem(`${stepPrefix}-changes-date`, moment().format('Y/M/D HH:mm:ss'))
  window.localStorage.setItem(`${stepPrefix}-changes`, JSON.stringify('1'))
}

export function getLastUnsavedSessionDate(stepPrefix) {
  return window.localStorage.getItem(`${stepPrefix}-changes-date`)
}

export function markAsSavedSession(stepPrefix) {
  window.localStorage.removeItem(`${stepPrefix}-changes`)
}

export function hasUnsavedSession(stepPrefix) {
  const value = window.localStorage.getItem(`${stepPrefix}-changes`)
  return JSON.parse(value) === '1'
}
